var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainbox"},[_c('recom'),_c('div',{staticClass:"footbox"},[_vm._v(" "+_vm._s(_vm.userinfo.admin_bottom_text || _vm.userinfo.admin_bottom_text || (_vm.projectinfo?_vm.projectinfo.technical_support:'') || `Powered by 成都元智盈创科技有限公司 © 2015-${ _vm.year > 2015 ? _vm.year : 2020 }`)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }